module.exports = __webpack_public_path__ + "static/media/Element_Pyro.ea877192.png";